// extracted by mini-css-extract-plugin
export default {"dropzone__container":"styles_dropzone__container__vHU1n"};